// Tests: src/app/migrations/migrations.spec.ts
import { MigrationDefinition } from './migration.types';

/**
 * Migration: V10 → V11
 *
 * Per-Punkt-Workflow bekommt eine `projectId`, damit beim Re-Workflow
 * (Hinzufuegen eines abgeschlossenen Punkts zu einem neuen Projekt) klar
 * ist, welches Projekt den aktuellen Workflow fuehrt.
 *
 * Upgrade:
 *  - Wenn `bp.workflow` existiert und `header.projects[0]` gesetzt ist:
 *    `workflow.projectId = header.projects[0].id` (best effort — es gibt
 *    keine historische Quelle der Wahrheit, dies ist eine plausible Heuristik).
 *  - `history`-Eintraege bekommen `kind: 'transition'` (optional, nur fuer
 *    saubere Typen — Lesecode behandelt fehlende kinds weiterhin als
 *    Transitionen).
 *
 * Downgrade:
 *  - `workflow.projectId` wird entfernt.
 *  - `kind`-Felder werden aus history-Eintraegen entfernt.
 *  - Vorhandene `reset`-Eintraege werden entfernt (das alte Schema kennt
 *    sie nicht). Das ist verlustig — wir behalten dazu eine
 *    `dataLossWarnings`-Notiz.
 */
export const migrationV10ToV11: MigrationDefinition = {
  fromVersion: 10,
  toVersion: 11,

  upgrade(doc: any): any {
    const wf = doc.workflow;
    if (wf) {
      const firstProject = doc.header?.projects?.[0];
      if (firstProject?.id && !wf.projectId) {
        wf.projectId = firstProject.id;
      }
      if (Array.isArray(wf.history)) {
        for (const e of wf.history) {
          if (e && typeof e === 'object' && !e.kind) {
            e.kind = 'transition';
          }
        }
      }
    }
    doc.version = 11;
    return doc;
  },

  downgrade(doc: any): any {
    const wf = doc.workflow;
    if (wf) {
      delete wf.projectId;
      if (Array.isArray(wf.history)) {
        wf.history = wf.history
          .filter((e: any) => !e || e.kind !== 'reset')
          .map((e: any) => {
            if (e && typeof e === 'object') {
              const { kind: _kind, ...rest } = e;
              return rest;
            }
            return e;
          });
      }
    }
    doc.version = 10;
    return doc;
  },

  dataLossWarnings: [
    'Beim Downgrade gehen Reset-Marker in workflow.history und workflow.projectId verloren'
  ]
};
